import useMagazineCoverColorAtom from './magazineCoverColorAtom';

export * from './magazineCoverColorAtom';

export default useMagazineCoverColorAtom;
